module.exports = __webpack_public_path__ + "static/media/Surskit_gaussian2.12a2b53b.png";